import { FormaPagoNoEfectivo } from "./pago";

export interface PagoRealizadoDesgloseFeriaModel {
    EsCredito: false;
    ImporteEfectivoAntesFeria: number;
    Conceptos: ConceptoPagoRealizado[];
}


export interface PagoRealizadoDesgloseFeriaResult extends PagoRealizadoDesgloseFeriaModel {
    /**Cantidad de feria en efectivo que se le devuelve al cliente */
    Feria : number;
    /**Cantidad de dinero que falta para que se acomplete el pago */
    Falta:  number;
}

/**Un DTO de un pago realizado por el usuario */
export interface PagoRealizadoCredito {
    EsCredito: true;
}

export type PagoRealizadoModel = PagoRealizadoDesgloseFeriaModel | PagoRealizadoCredito;
export const pagoRealizadoInicial: PagoRealizadoModel = { EsCredito: false, Conceptos: [], ImporteEfectivoAntesFeria: 0}
/**Un DTO de un pago realizado por el usuario */
export type PagoRealizado  = PagoRealizadoDesgloseFeriaModel | PagoRealizadoCredito;

/**Concepto de un pago realizado */
export interface ConceptoPagoRealizado {
    /**Forma de pago */
    FormaPago: FormaPagoNoEfectivo;

    /**Monto de este concepto de pago */
    Monto: number;

    /**Ultimos 4 dígitos de la cuenta/tarjeta/cheque dependiendo de la forma de pago */
    UltDigitosCuenta: string;
}


// WEBPACK FOOTER //
// ./app/models/pagorealizado.ts